var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_9dz8e9dwd7n1 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6552 1H3V19H17V5.3758L12.6552 1ZM12.8298 2.0242L15.9831 5.2H12.8298V2.0242ZM3.59574 18.4V1.6H12.234V5.8H16.4043V18.4H3.59574Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1708 6.9248H6.48799C6.25743 6.9248 6.07031 7.0738 6.07031 7.25814C6.07031 7.44247 6.25743 7.59147 6.48799 7.59147H13.1708C13.4014 7.59147 13.5885 7.44247 13.5885 7.25814C13.5885 7.0738 13.4014 6.9248 13.1708 6.9248Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.1708 10.5908H6.48799C6.25743 10.5908 6.07031 10.7398 6.07031 10.9242C6.07031 11.1085 6.25743 11.2575 6.48799 11.2575H13.1708C13.4014 11.2575 13.5885 11.1085 13.5885 10.9242C13.5885 10.7398 13.4014 10.5908 13.1708 10.5908Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.1708 14.2578H6.48799C6.25743 14.2578 6.07031 14.4068 6.07031 14.5911C6.07031 14.7755 6.25743 14.9245 6.48799 14.9245H13.1708C13.4014 14.9245 13.5885 14.7755 13.5885 14.5911C13.5885 14.4068 13.4014 14.2578 13.1708 14.2578Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.43e3f1d8c5a193f3e8bab3a967f49f34.svg";
export { ForwardRef as ReactComponent };